import { render, staticRenderFns } from "./Publics.vue?vue&type=template&id=5f60f425"
import script from "./Publics.vue?vue&type=script&lang=js"
export * from "./Publics.vue?vue&type=script&lang=js"
import style0 from "./Publics.vue?vue&type=style&index=0&id=5f60f425&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports